import { render, staticRenderFns } from "./ContactUsColumns.vue?vue&type=template&id=2cc8a92b&scoped=true"
import script from "./ContactUsColumns.vue?vue&type=script&lang=js"
export * from "./ContactUsColumns.vue?vue&type=script&lang=js"
import style0 from "./ContactUsColumns.vue?vue&type=style&index=0&id=2cc8a92b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc8a92b",
  null
  
)

export default component.exports